import { render, staticRenderFns } from "./Logistics.vue?vue&type=template&id=eaa7d390&scoped=true&"
import script from "./Logistics.vue?vue&type=script&lang=js&"
export * from "./Logistics.vue?vue&type=script&lang=js&"
import style0 from "./Logistics.vue?vue&type=style&index=0&id=eaa7d390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa7d390",
  null
  
)

export default component.exports